/**
 * 设备检测工具
 * 基于User Agent判断设备类型
 */

/**
 * 检测是否为移动设备
 * @returns {boolean} 如果是移动设备返回true，否则返回false
 */
export function isMobileDevice() {
  const userAgent = navigator.userAgent.toLowerCase();
  
  // 移动设备关键词
  const mobileKeywords = [
    'android',
    'iphone',
    'ipad',
    'ipod',
    'blackberry',
    'windows phone',
    'mobile',
    'webos',
    'opera mini',
    'iemobile',
    'wpdesktop'
  ];
  
  // 检查是否包含移动设备关键词
  return mobileKeywords.some(keyword => userAgent.includes(keyword));
}

/**
 * 检测是否为平板设备
 * @returns {boolean} 如果是平板设备返回true，否则返回false
 */
export function isTabletDevice() {
  const userAgent = navigator.userAgent.toLowerCase();
  
  // 平板设备关键词
  const tabletKeywords = [
    'ipad',
    'android.*tablet',
    'kindle',
    'silk',
    'playbook',
    'tablet'
  ];
  
  // 检查是否包含平板设备关键词
  return tabletKeywords.some(keyword => {
    if (keyword.includes('.*')) {
      // 使用正则表达式匹配
      const regex = new RegExp(keyword);
      return regex.test(userAgent);
    }
    return userAgent.includes(keyword);
  });
}

/**
 * 检测是否为桌面设备
 * @returns {boolean} 如果是桌面设备返回true，否则返回false
 */
export function isDesktopDevice() {
  return !isMobileDevice() && !isTabletDevice();
}

/**
 * 获取设备类型
 * @returns {string} 返回设备类型：'mobile', 'tablet', 'desktop'
 */
export function getDeviceType() {
  if (isMobileDevice()) {
    return 'mobile';
  } else if (isTabletDevice()) {
    return 'tablet';
  } else {
    return 'desktop';
  }
}

/**
 * 检测是否应该显示移动端布局
 * @returns {boolean} 如果应该显示移动端布局返回true，否则返回false
 */
export function shouldShowMobileLayout() {
  return isMobileDevice();
}

/**
 * 检测是否应该显示桌面端布局
 * @returns {boolean} 如果应该显示桌面端布局返回true，否则返回false
 */
export function shouldShowDesktopLayout() {
  return isDesktopDevice() || isTabletDevice();
}